export default __webpack_public_path__ + "static/media/Rectangle 230.4c127992.svg";